import React, { useState, useContext, useRef } from 'react'
import PropTypes from 'prop-types'
import { Dimensions, Platform, TouchableOpacity, View } from 'react-native'
import {
  Icon,
  VFText,
  VFButton,
  VFDropdown,
  QuickActionMenu
} from '@vfgroup-oneplatform/foundation/Components'

import {
  Colors,
  Images,
  useTheme
} from '@vfgroup-oneplatform/foundation/Components/Themes'

// import CameraStep from '../CameraStep'
import CustomModal from '../CustomModal'
import CustomButton from '../CustomButton'
import CustomErrorScreen from '../CustomErrorScreen'
import CustomInput from '../CustomInput/CustomInput'

import UnlimitedContext from '../../Context'

import {
  genders,
  citiesList,
  yearsOptions,
  monthOptions,
  issuingCountryOptions
} from '../../Utils/id'

import styles from './IdStep.Style'

import { getThemeImages } from '../../Themes'
import ReactNativeModal from 'react-native-modal'
import CameraStep from '@vfal-lab/rn-vfg-renewals-fix/Components/CameraStep'

const validate = ({ value, fn, text }) => {
  const formatError = fn(value) ? '' : text
  const message = formatError
  const isError = Boolean(formatError)
  return { message, isError }
}

const IdStep = ({
  goNext,
  validateName,
  validateEmail,
  changeUserData,
  createCustomer,
  checkCustomerByID,
  validatePersonalNumber
}) => {
  const theme = useTheme()
  const themedImages = getThemeImages(theme.name)

  const {
    data: {
      customerData: { fixId, isExisting, isCreating },
      idData: {
        name,
        city,
        email,
        gender,
        selfie,
        backId,
        surname,
        frontId,
        birthday,
        selfieB64,
        backIdB64,
        frontIdB64,
        documentId,
        documentYear,
        documentMonth,
        documentCountry
      }
    }
  } = useContext(UnlimitedContext)

  const onIdUploadClick = () => setShowCamera(true)
  const [showCamera, setShowCamera] = useState(false)
  const [isValidating, setIsValidating] = useState(false)
  const [error, setError] = useState({ show: false, error: null })

  const isUploadDisabled =
    Boolean(frontIdB64) && Boolean(backIdB64) && Boolean(selfieB64)

  const onDataChange = (value, field) => changeUserData({ field, value })

  const isButtonDisabled = () => {
    let isDisabled = true
    if (isExisting && fixId) {
      isDisabled = !(validatePersonalNumber(documentId) && isUploadDisabled)
    } else {
      isDisabled = !(
        isUploadDisabled &&
        Boolean(birthday) &&
        validateName(name) &&
        validateEmail(email) &&
        validateName(surname) &&
        Boolean(documentYear) &&
        Boolean(documentMonth) &&
        Boolean(documentCountry) &&
        validatePersonalNumber(documentId)
      )
    }
    return isDisabled
  }

  const handleNextClick = () => {
    if (isExisting && fixId) {
      checkCustomerByID({
        body: {
          fixId: fixId,
          documentId: documentId
        },
        onStart: () => {
          setIsValidating(true)
        },
        onSuccess: () => {
          setIsValidating(false)
          goNext()
        },
        onError: err => {
          setIsValidating(false)
          setError({ show: true, error: err })
        }
      })
    } else {
      createCustomer({
        body: {
          name,
          city,
          email,
          gender,
          surname,
          birthday,
          selfieB64,
          backIdB64,
          frontIdB64,
          documentId,
          documentYear,
          documentMonth,
          documentCountry
        },
        onStart: () => { },
        onSuccess: () => goNext(),
        onError: err => {
          setError({ show: true, error: err })
        }
      })
    }
  }

  // Camera Web



  const renderCamera = () => {
    return (
      <CameraStep
        toggleCameraModal={() => setShowCamera(false)}
        frontIdPhoto={frontId}
        setFrontIdPhoto={e => onDataChange(e, 'frontId')}
        setBackIdPhoto={e => onDataChange(e, 'backId')}
        setSelfie={e => onDataChange(e, 'selfie')}
        backIdPhoto={backId}
        selfie={selfie}
        setBackIdPhotoBase64={e => onDataChange(e, 'backIdB64')}
        setSelfieBase64={e => onDataChange(e, 'selfieB64')}
        setFrontIdPhotoBase64={e => {
          onDataChange(e, 'frontIdB64')
        }}
      />
    )
  }


  return (
    <>
      <View style={styles.idStep}>
        <VFText style={styles.header} i18nKey="unlimited_id_title" />
        <VFText style={styles.description} i18nKey="unlimited_id_description" />
        {/* Form */}
        <View style={styles.card(theme)}>
          {/* Form Header */}
          <View style={styles.formHeader}>
            <Icon
              size={40}
              type="image"
              style={styles.headerIcon}
              name={themedImages.id_icon}
            />
            <View>
              <VFText i18nKey="unlimited_id_form_title" />
              <VFText
                i18nKey="unlimited_id_form_subtitle"
                style={styles.headerSubtitle}
              />
            </View>
          </View>
          {/* Id Uploader */}
          <View style={styles.uploadHolder}>
            {/* <VFText
              i18nKey='unlimited_id_upload_description'
              style={styles.idUploadDescription}
            /> */}
            <VFButton
              onPress={onIdUploadClick}
              disabled={isUploadDisabled}
              type={isUploadDisabled ? 'tertiary' : 'primary'}
              title={
                isUploadDisabled
                  ? 'unlimited_id_uploaded_button'
                  : 'unlimited_id_upload_button'
              }
            />
          </View>
          <View style={styles.formHolder}>
            {isExisting && fixId ? (
              <IdRenewalForm
                documentId={documentId}
                onChange={onDataChange}
                validateFn={validatePersonalNumber}
              />
            ) : (
              <IdForm
                name={name}
                city={city}
                email={email}
                gender={gender}
                surname={surname}
                birthday={birthday}
                onChange={onDataChange}
                documentId={documentId}
                documentYear={documentYear}
                validateName={validateName}
                validateEmail={validateEmail}
                documentMonth={documentMonth}
                documentCountry={documentCountry}
                validatePersonalNumber={validatePersonalNumber}
              />
            )}
          </View>
          {/* Divider */}
          <View style={styles.divider} />
          {/* Button */}
          <CustomButton
            style={styles.button}
            onPress={handleNextClick}
            disabled={isButtonDisabled()}
            title="unlimited_next_step_button"
            loadingTitle="unlimited_validating"
            isLoading={isCreating || isValidating}
          />
        </View>
      </View>
      {Platform.OS === 'web' && Dimensions.get('window').width > 700 ?
        <ReactNativeModal
          isVisible={showCamera}
          backdropOpacity={0.5}
          onSwipeComplete={() => setShowCamera(false)}
          onBackdropPress={() => setShowCamera(false)}
          propagateSwipe
          hideModalContentWhileAnimating
          hardwareAccelerated
          backdropTransitionOutTiming={0}
          style={{
            justifyContent: 'flex-end',
            margin: '0 !important',
            minWidth: 1920,
            maxWidth: 1920,
          }}
        >
          <View
            style={{
              minWidth: '600px',
              maxWidth: '600px',
              height: 'auto',
              backgroundColor: theme.colors.quickActionGradientColors.secondary,
              margin: 'auto',
              padding: '20px',
              paddingTop: null,
              borderRadius: "7px",
            }}
            onStartShouldSetResponder={() => true}>
            {renderCamera()}
          </View>
        </ReactNativeModal>
        :
        <QuickActionMenu
          type="secondary"
          theme={theme}
          visible={showCamera}
          close={() => setShowCamera(false)}
          hideHeader={true}
          style={{ height: '100%', margin: 0 }}
        >
          {renderCamera()}
        </QuickActionMenu>}

      {Platform.OS === 'web' && Dimensions.get('window').width > 700 ?
        <ReactNativeModal
          isVisible={error.show}
          backdropOpacity={0.5}
          onSwipeComplete={() => setError({ show: false, error: null })}
          onBackdropPress={() => setError({ show: false, error: null })}
          propagateSwipe
          hideModalContentWhileAnimating
          hardwareAccelerated
          backdropTransitionOutTiming={0}
          style={{
            justifyContent: 'flex-end',
            margin: '0 !important',
            minWidth: 1920,
            maxWidth: 1920,
          }}
        >
          <View
            style={{
              minWidth: '600px',
              maxWidth: '600px',
              height: 'auto',
              backgroundColor: theme.colors.quickActionGradientColors.secondary,
              margin: 'auto',
              padding: '20px',
              paddingTop: null,
              borderRadius: "7px",
            }}
            onStartShouldSetResponder={() => true}>
            <CustomErrorScreen
              text={error.error}
              onPress={() => setError({ show: false, error: null })}
            />
          </View>
        </ReactNativeModal>
        : <QuickActionMenu
          type="secondary"
          isVisible={error.show}
          title="unlimited_error"
          headerStyle={styles.errorTitle}
          toggleModal={() => setError({ show: false, error: null })}
        >
          <CustomErrorScreen
            text={error.error}
            onPress={() => setError({ show: false, error: null })}
          />
        </QuickActionMenu>}
    </>
  )
}

IdStep.propTypes = {
  goNext: PropTypes.func,
  validateName: PropTypes.func,
  validateEmail: PropTypes.func,
  changeUserData: PropTypes.func,
  createCustomer: PropTypes.func,
  checkCustomerByID: PropTypes.func,
  validatePersonalNumber: PropTypes.func
}

IdStep.defaultProps = {
  goNext: () => { },
  changeUserData: () => { },
  createCustomer: () => { },
  checkCustomerByID: () => { },
  validateEmail: () => { },
  validatePersonalNumber: () => { }
}

const IdRenewalForm = ({ documentId, onChange, validateFn }) => {
  return (
    <PersonalNumberField
      value={documentId}
      onChange={onChange}
      validateFn={validateFn}
    />
  )
}

IdRenewalForm.propTypes = {
  onChange: PropTypes.func,
  validateFn: PropTypes.func,
  documentId: PropTypes.string
}

const IdForm = ({
  name,
  city,
  email,
  gender,
  surname,
  birthday,
  onChange,
  documentId,
  validateName,
  documentYear,
  documentMonth,
  documentCountry,
  validateEmail,
  validatePersonalNumber
}) => {
  return (
    <View>
      <View style={styles.inlineFields}>
        <View style={styles.flex}>
          <NameField
            value={name}
            onChange={onChange}
            validateFn={validateName}
          />
        </View>
        <View style={styles.flex}>
          <SurnameField
            value={surname}
            onChange={onChange}
            validateFn={validateName}
          />
        </View>
      </View>
      <View style={styles.flex}>
        <BirthDate value={birthday} onChange={onChange} />
      </View>
      <View style={styles.flex}>
        <EmailField
          value={email}
          onChange={onChange}
          validateFn={validateEmail}
        />
      </View>
      <PersonalNumberField
        value={documentId}
        onChange={onChange}
        validateFn={validatePersonalNumber}
      />
      <View
        style={[
          styles.inlineFields,
          styles.extraPadding,
          styles.spaceTop,
          styles.dropdown(Platform, 70)
        ]}
      >
        <View style={[styles.flex, styles.spaceRight]}>
          <GenderField value={gender} onChange={onChange} />
        </View>
        <View style={[styles.flex, styles.spaceRight]}>
          <CitiesList value={city} onChange={onChange} />
        </View>
      </View>
      <View style={[styles.spaceTop]}>
        <IssuingCountryField value={documentCountry} onChange={onChange} />
      </View>
      <View style={[styles.inlineFields, styles.spaceTop]}>
        <View style={[styles.flex]}>
          <ExpirationMonth value={documentMonth} onChange={onChange} />
        </View>
        <View style={styles.flex}>
          <ExpirationYear value={documentYear} onChange={onChange} />
        </View>
      </View>
    </View>
  )
}

IdForm.propTypes = {
  name: PropTypes.string,
  city: PropTypes.string,
  email: PropTypes.string,
  gender: PropTypes.string,
  onChange: PropTypes.func,
  surname: PropTypes.string,
  birthday: PropTypes.string,
  documentId: PropTypes.string,
  validateName: PropTypes.func,
  validateEmail: PropTypes.func,
  documentYear: PropTypes.number,
  documentMonth: PropTypes.number,
  documentCountry: PropTypes.string,
  validatePersonalNumber: PropTypes.func
}

const errorDefaults = {
  isError: false,
  message: ''
}

const PersonalNumberField = ({ value, onChange, validateFn }) => {
  const [, setFieldRef] = useState(null)
  const [error, setError] = useState(errorDefaults)

  const [id, setId] = useState(value)

  const handleBlur = () => onChange(id, 'documentId')
  const handleTextChange = text => setId(text)

  const handleValidation = val => {
    const data = validate({
      value: val,
      fn: validateFn,
      text: 'unlimited_invalid_id'
    })
    setError(data)
    return data
  }

  return (
    <>
      <CustomInput
        value={id}
        onBlur={handleBlur}
        isError={error.isError}
        fieldRef={setFieldRef}
        validator={handleValidation}
        errorMessage={error.message}
        onChangeText={handleTextChange}
        label="unlimited_id_personal_number_label"
        resetValidation={() => setError(errorDefaults)}
      />
      <VFText i18nKey="unlimited_id_helper_text" style={styles.helper} />
    </>
  )
}

PersonalNumberField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  validateFn: PropTypes.func
}

const NameField = ({ value, onChange, validateFn }) => {
  const [, setFieldRef] = useState(null)
  const [name, setName] = useState(value)
  const [error, setError] = useState(errorDefaults)

  const handleBlur = () => onChange(name, 'name')
  const handleTextChange = text => setName(text)

  const handleValidation = val => {
    const data = validate({
      value: val,
      fn: validateFn,
      text: 'unlimited_invalid_name'
    })
    setError(data)
    return data
  }

  return (
    <CustomInput
      value={name}
      onBlur={handleBlur}
      isError={error.isError}
      fieldRef={setFieldRef}
      validator={handleValidation}
      errorMessage={error.message}
      onChangeText={handleTextChange}
      label="unlimited_id_name_label"
      resetValidation={() => setError(errorDefaults)}
    />
  )
}

NameField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  validateFn: PropTypes.func
}

const SurnameField = ({ value, onChange, validateFn }) => {
  const [, setFieldRef] = useState(null)
  const [surname, setSurname] = useState(value)
  const [error, setError] = useState(errorDefaults)

  const handleBlur = () => onChange(surname, 'surname')
  const handleTextChange = text => setSurname(text)

  const handleValidation = val => {
    const data = validate({
      value: val,
      fn: validateFn,
      text: 'unlimited_invalid_surname'
    })
    setError(data)
    return data
  }

  return (
    <CustomInput
      value={surname}
      onBlur={handleBlur}
      isError={error.isError}
      fieldRef={setFieldRef}
      validator={handleValidation}
      errorMessage={error.message}
      onChangeText={handleTextChange}
      label="unlimited_id_surname_label"
      resetValidation={() => setError(errorDefaults)}
    />
  )
}

SurnameField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  validateFn: PropTypes.func
}

const EmailField = ({ value, onChange, validateFn }) => {
  const [, setFieldRef] = useState(null)
  const [email, setEmail] = useState(value)
  const [error, setError] = useState(errorDefaults)
  const handleBlur = () => onChange(email, 'email')
  const handleTextChange = text => setEmail(text)
  const handleValidation = val => {
    const data = validate({
      value: val,
      fn: validateFn,
      text: 'unlimited_invalid_email'
    })
    setError(data)
    return data
  }
  return (
    <CustomInput
      value={email}
      onBlur={handleBlur}
      autoCapitalize="none"
      isError={error.isError}
      fieldRef={setFieldRef}
      validator={handleValidation}
      errorMessage={error.message}
      onChangeText={handleTextChange}
      label="unlimited_id_email_label"
      resetValidation={() => setError(errorDefaults)}
    />
  )
}

EmailField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  validateFn: PropTypes.func
}

const GenderField = ({ value, onChange }) => {
  const handleValueChange = text => onChange(text, 'gender')

  return (
    <View>
      <VFDropdown
        showArrow
        zIndex={91}
        value={value}
        items={genders}
        defaultValue={value}
        borderColor={Colors.vfGrey}
        style={styles.dropdownHeight}
        labelStyle={styles.dropdownLabel}
        onValueChange={handleValueChange}
        placeholder={{ label: 'unlimited_gender' }}
        flatListProps={{ nestedScrollEnabled: true }}
        dropDownStyle={styles.dropdown(Platform.OS, 50)}
      />
    </View>
  )
}

GenderField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
}

const CitiesList = ({ value, onChange }) => {
  const handleValueChange = text => onChange(text, 'city')

  return (
    <View>
      <VFDropdown
        showArrow
        zIndex={91}
        value={value}
        items={citiesList}
        defaultValue={value}
        borderColor={Colors.vfGrey}
        style={styles.dropdownHeight}
        labelStyle={styles.dropdownLabel}
        onValueChange={handleValueChange}
        placeholder={{ label: 'unlimited_city' }}
        flatListProps={{ nestedScrollEnabled: true }}
        dropDownStyle={styles.dropdown(Platform.OS, 200)}
      />
    </View>
  )
}

CitiesList.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
}

const BirthDate = ({ onChange }) => {
  const theme = useTheme()

  const [day, setDay] = useState('')
  const [year, setYear] = useState('')
  const [month, setMonth] = useState('')

  const [dayRef, setDayRef] = useState(null)

  const [yearRef, setYearRef] = useState(null)

  const [monthRef, setMonthRef] = useState(null)

  const [error, setError] = useState(errorDefaults)

  const handleBlur = () => {
    const date = new Date(
      parseInt(year, 10),
      parseInt(month, 10) - 1,
      parseInt(day, 10)
    )
    const { isError } = handleValidation()
    onChange(isError ? '' : date.toISOString(), 'birthday')
  }

  const validateYear = y => {
    const parsed = parseInt(y, 10)
    const isError =
      isNaN(parsed) || parsed < 1900 || parsed > new Date().getFullYear()
    return {
      isError: isError,
      message: isError ? 'unlimited_birthday_year_error' : null
    }
  }

  const validateMonth = m => {
    const parsed = parseInt(m, 10)
    const isError = isNaN(parsed) || parsed < 1 || parsed > 12
    return {
      isError: isError,
      message: isError ? 'unlimited_birthday_month_error' : null
    }
  }

  const validateDay = (y, m, d) => {
    const parsedY = parseInt(y, 10)
    const parsedM = parseInt(m, 10)
    const parsedD = parseInt(d, 10)
    const daysOfMonth = new Date(parsedY, parsedM - 1, 0).getDate()
    const isError = isNaN(parsedD) || parsedD < 1 || parsedD > daysOfMonth
    return {
      isError: isError,
      message: isError ? 'unlimited_birthday_day_error' : null
    }
  }

  const handleValidation = () => {
    let isDayError = false
    let dayError = null
    const { isError: isYearError, message: yearError } = validateYear(year)
    const { isError: isMonthError, message: monthError } = validateMonth(month)
    if (!isYearError && !isMonthError) {
      const data = validateDay(year, month, day)
      isDayError = data.isError
      dayError = data.message
    }
    setError({
      isError: isYearError || isMonthError || isDayError,
      message: yearError ?? monthError ?? dayError ?? null
    })
    return {
      isError: isYearError || isMonthError || isDayError,
      message: yearError ?? monthError ?? dayError ?? null
    }
  }

  const handleTextChange = (field, val) => {
    const parsed = parseInt(val.replace(/[^0-9]/g, ''), 10)
    const value = isNaN(parsed) ? '' : parsed.toString()
    switch (field) {
      case 'day':
        if (value.length > 2) {
          dayRef.setValue(day)
        } else {
          dayRef.setValue(value)
          setDay(value)
        }
        break
      case 'month':
        if (value.length > 2) {
          monthRef.setValue(month)
        } else {
          monthRef.setValue(value)
          setMonth(value)
        }
        break
      case 'year':
        if (value.length > 4) {
          yearRef.setValue(year)
        } else {
          yearRef.setValue(value)
          setYear(value)
        }
        break
      default:
        break
    }
  }

  return (
    <View>
      <VFText
        i18nKey="unlimited_home_birthday"
        style={styles.inputLabel(theme, error.isError)}
      />
      <View style={styles.inputsContainer}>
        <View style={styles.datesContainer}>
          <CustomInput
            value={day}
            fieldRef={setDayRef}
            isError={error.isError}
            keyboardType={'numeric'}
            label="unlimited_birthday_day"
            onBlur={() => handleBlur('day')}
            resetValidation={() => setError(errorDefaults)}
            onChangeText={val => handleTextChange('day', val)}
          />
        </View>
        <View style={styles.datesContainer}>
          <CustomInput
            value={month}
            fieldRef={setMonthRef}
            isError={error.isError}
            keyboardType={'numeric'}
            label="unlimited_birthday_month"
            onBlur={() => handleBlur('month')}
            resetValidation={() => setError(errorDefaults)}
            onChangeText={val => handleTextChange('month', val)}
          />
        </View>
        <View style={styles.datesContainer}>
          <CustomInput
            value={year}
            fieldRef={setYearRef}
            isError={error.isError}
            keyboardType={'numeric'}
            label="unlimited_birthday_year"
            onBlur={() => handleBlur('year')}
            resetValidation={() => setError(errorDefaults)}
            onChangeText={val => handleTextChange('year', val)}
          />
        </View>
      </View>
      {error.isError ? (
        <VFText i18nKey={error.message} style={styles.dateError(theme)} />
      ) : null}
    </View>
  )
}

BirthDate.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
}

const IssuingCountryField = ({ value, onChange }) => {
  const handleValueChange = text => onChange(text, 'documentCountry')
  return (
    <VFDropdown
      showArrow
      zIndex={1}
      value={value}
      defaultValue={value ?? ''}
      borderColor={Colors.vfGrey}
      items={issuingCountryOptions}
      style={styles.dropdownHeight}
      onValueChange={handleValueChange}
      labelStyle={styles.dropdownLabel}
      flatListProps={{ nestedScrollEnabled: true }}
      dropDownStyle={styles.dropdown(Platform.OS, 90)}
      placeholder={{ label: 'unlimited_id_country_label' }}
    />
  )
}

IssuingCountryField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
}

const ExpirationMonth = ({ value, onChange }) => {
  const handleValueChange = text => onChange(text, 'documentMonth')
  return (
    <View>
      <VFDropdown
        showArrow
        zIndex={9}
        value={value}
        items={monthOptions}
        defaultValue={value ?? ''}
        borderColor={Colors.vfGrey}
        style={styles.dropdownHeight}
        labelStyle={styles.dropdownLabel}
        onValueChange={handleValueChange}
        flatListProps={{ nestedScrollEnabled: true }}
        dropDownStyle={styles.dropdown(Platform.OS, 40)}
        placeholder={{ label: 'unlimited_id_month_label' }}
        containerStyle={{ zIndex: 99 }}
      />
      <View style={styles.helperTxt}>
        <VFText
          accessibilityRole="text"
          i18nKey="unlimited_expiration_month_label"
        />
      </View>
    </View>
  )
}

ExpirationMonth.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
}

const ExpirationYear = ({ value, onChange }) => {
  const handleValueChange = text => onChange(text, 'documentYear')

  return (
    <View>
      <VFDropdown
        showArrow
        zIndex={9}
        value={value}
        items={yearsOptions}
        defaultValue={value}
        borderColor={Colors.vfGrey}
        style={styles.dropdownHeight}
        labelStyle={styles.dropdownLabel}
        onValueChange={handleValueChange}
        flatListProps={{ nestedScrollEnabled: true }}
        dropDownStyle={styles.dropdown(Platform.OS, 40)}
        placeholder={{ label: 'unlimited_id_year_label' }}
        containerStyle={{ zIndex: 99 }}
      />
      <View style={styles.helperTxt}>
        <VFText
          accessibilityRole="text"
          i18nKey="unlimited_expiration_year_label"
        />
      </View>
    </View>
  )
}

ExpirationYear.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
}

export default IdStep
